import imageOne from '@/assets/images/cities/princeAlbert1.jpg'
import imageTwo from '@/assets/images/cities/princeAlbert2.jpg'
import imageThree from '@/assets/images/cities/princeAlbert3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Prince Albert',
  writeup: '',
  website: 'PrinceAlbertNotaryPublic.com',
  url: 'https://www.princealbertnotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(306) 500-5160',
      hours: {
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '',
        friday: '9:00AM to 12:00PM and 1:00PM to 5:00PM',
        saturday: '',
        sunday: ''
      },
      address: '11th Street East Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/saskatchewan/cities/princeAlbert.js